<template>
    <group-checkout-layout
        :page-title="'Purchase Memberships for ' + $page.props.group.name"
    >
        <div class="flex h-screen w-full flex-col lg:flex-row">
            <div class="h-full bg-white p-4 lg:w-1/2 lg:p-16">
                <div class="mx-auto h-full max-w-lg lg:mr-0 lg:ml-auto">
                    <div class="mb-16 text-[32px] font-semibold">Checkout</div>
                    <div class="mb-8 flex items-center justify-between">
                        <div class="text-[20px] font-semibold">
                            Order Summary
                        </div>
                        <div class="">
                            <group-buy-membership-modal
                                continue-button-text="Update Cart"
                                :allow-cancel="false"
                                :existing-memberships-in-cart="
                                    membershipsInCart
                                "
                            >
                                <span class="link font-medium">Edit Cart</span>
                            </group-buy-membership-modal>
                        </div>
                    </div>
                    <div class="flex flex-col gap-4 text-[15px]">
                        <template
                            v-for="membershipItem in displayMembershipsInCart"
                        >
                            <div
                                v-if="membershipItem.qty > 0"
                                class="flex items-center gap-4 border-b border-gray-200 pb-4"
                            >
                                <div
                                    class="rounded rounded-full bg-blue-500 px-3 py-2 font-medium text-white"
                                >
                                    {{ membershipItem.planLength }} Day
                                </div>
                                <div class="">
                                    {{ membershipItem.perPriceUsd }} USD •
                                    {{ membershipItem.qty }}
                                    Memberships
                                </div>
                                <div class="ml-auto">
                                    {{ membershipItem.totalUsd }}
                                </div>
                            </div>
                        </template>
                    </div>

                    <div class="mt-8 mb-8">
                        <div class="flex flex-col gap-2">
                            <div class="flex justify-between">
                                <div class="">
                                    Subtotal ({{ totalMembershipsInCart }}
                                    memberships)
                                </div>
                                <div class="">{{ subtotal }} USD</div>
                            </div>

                            <div class="flex justify-between">
                                <div class="">Taxes</div>
                                <div class="">$0.00 USD</div>
                            </div>
                            <div class="flex justify-between">
                                <div class="">
                                    <div class="">
                                        Discount ({{ discountMessage }})
                                    </div>
                                </div>
                                <div class="">{{ discount }} USD</div>
                            </div>
                            <hr/>
                            <div class="flex justify-between font-semibold">
                                <div class="">Total</div>
                                <div class="">{{ total }} USD</div>
                            </div>
                        </div>
                    </div>

                    <group-memberships-discount-notice
                        :next-discount-tier="nextDiscountTier"
                    ></group-memberships-discount-notice>
                </div>
            </div>

            <!-- // cart-->
            <div class="h-full bg-gray-50 p-16 lg:w-1/2">
                <div class="mx-auto max-w-lg lg:ml-0 lg:mr-auto">
                    <div class="mb-4 text-[20px] font-bold">
                        Payment Information
                    </div>
                    <div class="">
                        <form @submit.prevent="submitForm" id="payment-form">
                            <div
                                id="payment-element"
                                class="bg-center bg-no-repeat"
                            >
                                <!-- Elements will create form elements here -->
                            </div>

                            <div
                                class="text-lg mt-4 rounded border-red-400 bg-red-400 p-4 font-semibold text-white"
                                v-if="paymentError"
                            >
                                {{ paymentError }}
                            </div>

                            <div
                                v-if="showAdditionalBillingFields"
                                class="mt-4"
                            >
                                <div class="grid grid-cols-2 gap-4 opacity-50">
                                    <div class="col-span-2">
                                        <form-input
                                            theme="dimmed"
                                            type="text"
                                            label="Billing Street"
                                            name="street"
                                            v-model="form.billingStreet"
                                        />
                                    </div>
                                    <div class="col-span-2">
                                        <form-input
                                            theme="dimmed"
                                            type="text"
                                            label="Billing City"
                                            name="city"
                                            v-model="form.billingCity"
                                        />
                                    </div>
                                    <div>
                                        <form-select
                                            theme="dimmed"
                                            label="Billing State"
                                            name="state"
                                            :allow-null="true"
                                            v-model="form.billingState"
                                            :options="stateOptions"
                                        />
                                    </div>
                                    <div>
                                        <form-input
                                            theme="dimmed"
                                            type="text"
                                            label="Billing Zip Code"
                                            name="postal_code"
                                            v-model="form.billingPostalCode"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="
                                    showAdditionalBillingFields &&
                                    (!form.billingStreet ||
                                        !form.billingCity ||
                                        !form.billingState ||
                                        !form.billingPostalCode)
                                "
                                class="mt-12 text-right"
                            >
                                <span
                                    class="btn btn-primary opacity-50 hover:cursor-not-allowed"
                                >
                                    Pay Now —— {{ total }} USD
                                </span>
                            </div>

                            <div
                                v-else
                                class="mt-8 flex items-center justify-start"
                            >
                                <button
                                    v-if="!submittingPayment"
                                    class="btn btn-primary"
                                >
                                    Pay Now —— {{ total }} USD
                                </button>
                                <span
                                    v-else
                                    class="btn btn-secondary opacity-50"
                                >
                                    Please wait, processing payment
                                </span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </group-checkout-layout>
</template>

<script>
import GroupCheckoutLayout from "@/_Layouts/GroupCheckoutLayout";
import GroupBuyMembershipsForm from "@/Components/GroupBuyMembershipsForm";
import NewModal from "@/Components/NewModal";
import GroupBuyMembershipModal from "@/Components/GroupBuyMembershipModal";
import GroupMembershipsDiscountNotice from "@/Components/GroupMembershipsDiscountNotice";
import FormInput from "@/Components/FormInput";
import FormSelect from "@/Components/FormSelect";

const stripe = Stripe(window.stripeKey);

export default {
    name: "Checkout",
    components: {
        FormSelect,
        FormInput,
        GroupMembershipsDiscountNotice,
        GroupBuyMembershipModal,
        NewModal,
        GroupBuyMembershipsForm,
        GroupCheckoutLayout,
    },
    props: {
        user: {
            type: Object,
            default: {},
        },
        displayMembershipsInCart: {
            type: Object,
            default: {},
        },
        membershipsInCart: {
            type: Object,
            default: {},
        },
        totalMembershipsInCart: {
            type: Number,
            default: 0,
        },
        subtotal: {
            type: String,
            default: "",
        },
        discountMessage: {
            type: String,
            default: "",
        },
        discount: {
            type: String,
            default: "",
        },
        total: {
            type: String,
            default: "",
        },
        nextDiscountTier: {
            type: Object,
            default: {},
        },
        order: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            stripePublicKey: window.stripeKey,
            stripElements: null,
            paymentElement: null,
            paymentError: "",
            form: this.$inertia.form({
                billingFullName:
                    this.user.first_name + " " + this.user.last_name,
                billingStreet: null,
                billingCity: this.user.city,
                billingState: this.user.state,
                billingPostalCode: null,
            }),
            showAdditionalBillingFields: false,
            submittingPayment: false,
        };
    },
    methods: {
        updatePaymentFields(event) {
            this.showAdditionalBillingFields = event.value.type !== "card";
        },
        submitForm() {
            let vm = this;

            if (this.submittingPayment) {
                return;
            } else {
                this.submittingPayment = true;
            }

            this.confirmPayment().then(function (result) {
                if (result.error) {
                    if (
                        result.error.type === "card_error" ||
                        result.error.type === "validation_error"
                    ) {
                        vm.paymentError = result.error.message;
                    } else {
                        vm.paymentError =
                            "An unexpected error occurred. Please try again later.";
                    }
                }

                vm.submittingPayment = false;
            });
        },
        async confirmPayment() {
            let confirmParams = {
                payment_method_data: {
                    billing_details: {
                        name: this.user.first_name + " " + this.user.last_name,
                        email: this.user.email,
                        phone: null,
                        postal_code: null,
                        address: {
                            line1: this.form.billingStreet,
                            city: this.form.billingCity,
                            state: this.form.billingState,
                            postal_code: this.form.billingPostalCode,
                            country: "US",
                        },
                    },
                },
                return_url:
                    window.siteDomain + "/finalize-group-order/" + this.order.id,
            };

            if (this.showAdditionalBillingFields) {
                confirmParams.shipping = {
                    name: this.user.first_name + " " + this.user.last_name,
                    address: {
                        line1: this.form.billingStreet,
                        city: this.form.billingCity,
                        state: this.form.billingState,
                        postal_code: this.form.billingPostalCode,
                        country: "US",
                    },
                };
            }

            let elements = this.stripElements;

            let result = stripe.confirmPayment({
                elements,
                confirmParams: confirmParams,
            });

            return result;
        },
    },
    mounted() {

        console.log(this.order);

        let stripeOptions = {
            hidePostalCode: true,
            clientSecret: this.order.payment_details.payment_intent_client_secret,
            appearance: {
                theme: "none",
                labels: "above",
                variables: {
                    colorPrimary: "#0D7AD9",
                    colorBackground: "#FFF",
                    colorText: "#343434",
                    colorDanger: "#df1b41",
                    fontFamily: "Ideal Sans, system-ui, sans-serif",
                    spacingUnit: "2px",
                    borderRadius: "3px",
                    fontSizeBase: "18px",
                    spacingGridColumn: "16px",
                    spacingGridRow: "16px",
                },
                rules: {
                    ".Label": {
                        fontWeight: 600,
                    },
                    ".Label--resting": {
                        color: "#8C969C",
                    },
                    ".Label--floating": {
                        color: "#8C969C",
                        fontSize: "12px",
                    },
                    ".Input": {
                        color: "#121212",
                        padding: ".5rem",
                        paddingLeft: ".75rem",
                    },
                    ".Error": {
                        fontSize: "14px",
                    },
                },
            },
            business: {name: "EMT-CE.com"},
            fields: {
                billingDetails: {
                    name: "auto",
                    email: "auto",
                    phone: "auto",
                    address: {
                        line1: "auto",
                        line2: "auto",
                        city: "auto",
                        state: "auto",
                        country: "auto",
                        postalCode: "auto",
                    },
                },
            },
        };

        this.stripElements = stripe.elements(stripeOptions);
        this.paymentElement = this.stripElements.create("payment");

        this.paymentElement.mount("#payment-element");

        this.paymentElement.on("change", this.updatePaymentFields);
    },
};
</script>

<style scoped></style>
